import Vue from "vue";
Vue.component("classification-systems-selector", {
    props: [
        "procurementTypeId",
        "value",
        "language",
        "showPartyConstraint",
        "insertNullValue",
        "nullValueLabel",
        "placeholder"
    ],
    data() {
        return {
            loading: false,
            myValue: this.value,
            classificationSystems: [],
            selectClassificationSystem: window.labels.selectClassificationSystem
        }
    },
    mounted() {
        const self = this;
        if (self.procurementTypeId) {
            self.refreshItems(self.procurementTypeId);
        }
    },
    watch: {
        myValue: function (value) {
            if (value != this.value) {
                this.$emit('update:value', value);
            }
        },
        procurementTypeId: function (value) {
            this.refreshItems(value);
        },
    },
    methods: {
        refreshItems: function (procurementTypeId) {
            const self = this;

            self.loading = true;
            self.$services.classificationSystemsService.getDropdownItems({
                procurementTypeId: procurementTypeId,
                language: self.language,
                showPartyConstraint: self.showPartyConstraint
            }).then((data) => {
                self.loading = false;

                if (self.insertNullValue) {
                    data.splice(0, 0, { id: null, text: self.nullValueLabel });
                }                

                self.classificationSystems = data;

                if (data.length > 0 && data.length == 1) {
                    self.myValue = data[0];
                    this.$emit('update:value', self.myValue);
                }
            });
        },
    },
    template: `
      	<div>
	  		<template v-if="loading"><loading></loading></template>
			<template v-else>
				<b-select v-model="myValue" :placeholder="placeholder">
					<option
						v-for="option in classificationSystems"
						:value="option"
						:key="option.id">
						{{ (showPartyConstraint && option.partyCodeConstraints != null ? (option.text + ' - only for ' + option.partyCodeConstraints) : option.text) }}
					</option>
				</b-select>
			</template>
      </div>
	`
});